// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"cdd11587","156":"76f979d4","184":"107bb471","237":"8e107b4b","265":"aba864d3","569":"ece2d882","638":"cfa09679","641":"b427f9da","718":"70c3f2ce","810":"1883f71b","852":"849fad64","881":"f1c385c6","971":"e8e94dfe"}[chunkId] + ".chunk.js";
};